import { gql } from "@apollo/client";

const GET_TEACHER_DETAILS = gql`
  query TeacherDetails($id: ID!) {
    teacherDetails(id: $id) {
      id
      name
      givenName
      familyName
      nonRomanGivenName
      nonRomanFamilyName
      avatar
      quickFacts
      aboutMe
      studyingTips
    }
  }
`;

export default GET_TEACHER_DETAILS;
